var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDietaryFiber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#414042;stroke-width:2;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.3,7.6c0-2-1.3-5-3.3-5.8c-2,0.8-3.3,3.8-3.3,5.8s1.3,5,3.3,5.8C17,12.6,18.3,9.8,18.3,7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.6,16.3c1.7,1.4,4.9,1,6.6,0.1c1.7-1,3.7-3.5,3.4-5.7c-1.7-1.4-4.9-1-6.6-0.1 C18.2,11.6,16.3,14.1,16.6,16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.3,24.7c1.7-1,3.7-3.5,3.4-5.7c-1.7-1.4-4.9-1-6.6-0.1c-1.7,1-3.7,3.5-3.4,5.7 C18.3,26,21.4,25.7,23.3,24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.7,16.3c1.7,1,5,1.3,6.6-0.1c0.3-2.1-1.7-4.7-3.4-5.7s-5-1.3-6.6,0.1C3,12.8,5,15.4,6.7,16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.7,24.7c1.7,1,5,1.3,6.6-0.1c0.3-2.1-1.7-4.7-3.4-5.7c-1.7-1-5-1.3-6.6,0.1C3,21.2,5,23.7,6.7,24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.4,15.1v12.6c0,0.3,0.3,0.5,0.6,0.5s0.6-0.2,0.6-0.5V15.1c0-0.3-0.3-0.5-0.6-0.5S14.4,14.8,14.4,15.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDietaryFiber);
export default __webpack_public_path__ + "static/media/DietaryFiber.3e2884f571d4af6ccecb91e4f531d51d.svg";
export { ForwardRef as ReactComponent };